import { useState, useEffect } from 'react'
import { matchSorter } from 'match-sorter'
import ReactSelect from 'react-select'

type Option = { value: string; label: string }

const findParents = (categories, selected, list) => {
  if (selected.parentId) {
    const parentCategory = categories.find((c) => c.id === selected.parentId)
    const parentName = findParents(categories, parentCategory, list)
    return list.concat(parentName).concat(selected.name)
  }

  return list.concat(selected.name)
}

const CategoryTypeahead = ({
  name,
  label,
  categories,
  value,
  className,
  onChange,
  reactSelectOptions = {},
}) => {
  const [options, setOptions] = useState<Option[]>([])
  const [categoryOptions, setCategoryOptions] = useState<Option[]>([])

  useEffect(() => {
    if (categories?.length > 0 && categoryOptions.length === 0) {
      const catOptions = categories.map((c) => {
        const parents = findParents(categories, c, [])
        const parentNames = parents.reduce((acc, category) => {
          if (acc === '') {
            return category
          }

          return `${acc} > ${category}`
        }, '')

        return {
          value: c.id,
          label: parentNames,
        }
      })

      setCategoryOptions(catOptions)
      setOptions(catOptions)
    }
  }, [categories])

  const onInputChange = (inputValue) => {
    const sortedOptions = inputValue
      ? matchSorter(categoryOptions, inputValue, { keys: ['label'] }).sort((a, b) =>
          a.label.localeCompare(b.label)
        )
      : categoryOptions

    setOptions(sortedOptions)
  }

  return (
    <div className={className}>
      {label && (
        <label className="mb-1 block text-sm text-gray-700" htmlFor={name}>
          {label}
        </label>
      )}
      <ReactSelect
        name={name}
        onInputChange={onInputChange}
        options={options}
        onChange={onChange}
        defaultValue={value}
        classNamePrefix="fs"
        {...reactSelectOptions}
      />
    </div>
  )
}

export default CategoryTypeahead
